var COLORS = {
  // Brand Colors
  fupaPrimary: '#003C69',
  fupaSecondary: '#0096DB',
  white: '#FFFFFF',
  black: '#000000',
  //Grey Shadows
  lightestGrey: '#F7F8FA',
  lighterGrey: '#EEF0F5',
  lightGrey: '#DEE2E9',
  grey: '#BCBEC6',
  darkGrey: '#848C9C',
  darkerGrey: '#616672',
  darkestGrey: '#343536',
  //Icon Colors for Branding
  yellowGreen: '#BEDE55',
  orange: '#E49C45',
  darkGreen: '#4F764E',
  brown: '#B4741B',
  asphalt: '#C3C6B7',
  yellow: '#F7D87B',
  deepBlue: '#055389',
  petrol: '#44B5BC',
  green: '#A6B851',
  wineRed: '#C53D4F',
  lightBlue: '#459CF9',
  smoke: '#516D73',
  orangeSoda: '#DB4816',
  yellowCard: '#F8D94D',
  //  MultiColor Icons
  greenIn: '#859E11',
  red: '#CC0000',
  //Win & Lose
  lightRed: '#FFCDD2',
  lightGreen: '#DCEDC8',
  //Text
  neonRed: '#D0021B',
  //Marketplace
  marketBlue: '#0068A9',
  // Focused Brand Colors
  fupaPrimaryFocused: '#17416D',
  fupaSecondaryFocused: '#0089C8'
};
var PTSANS = '"PT Sans"' + ' , ' + 'sans-serif';
var OSWALD = '"Oswald"' + ', "Arial Narrow", "Avenir Next Condensed", "MS UI Gothic", sans‑serif';
var FONTS = {
  //Font Family
  PTSans: PTSANS,
  Oswald: OSWALD,
  //Font Weight
  regular: 400,
  bold: 700,
  //Font Sizes
  64: '4rem',
  42: '2.625rem',
  24: '1.5rem',
  20: '1.25rem',
  18: '1.125rem',
  16: '1rem',
  14: '0.875rem',
  12: '0.75rem',
  10: '0.625rem'
};
var ICONSIZES = {
  72: '4.5rem',
  64: '4rem',
  32: '2rem',
  28: '1.75rem',
  24: '1.5rem',
  20: '1.25rem',
  16: '1rem',
  14: '0.875rem',
  12: '0.75rem'
};
var SIZES = {
  400: '25rem',
  216: '13.5rem',
  212: '13.25rem',
  148: '9.25rem',
  116: '7.25rem',
  112: '7rem',
  96: '6rem',
  88: '5.5rem',
  84: '5.25rem',
  80: '5rem',
  72: '4.5rem',
  68: '4.25rem',
  64: '4rem',
  56: '3.5rem',
  52: '3.25rem',
  48: '3rem',
  46: '2.875rem',
  44: '2.75rem',
  42: '2.625rem',
  40: '2.5rem',
  36: '2.25rem',
  34: '2.125rem',
  //Rows with padding: total height 42px
  32: '2rem',
  30: '1.875rem',
  28: '1.75rem',
  24: '1.5rem',
  20: '1.25rem',
  18: '1.125rem',
  16: '1rem',
  14: '0.875rem',
  12: '0.75rem',
  10: '0.625rem',
  8: '0.5rem',
  6: '0.375rem',
  4: '0.25rem',
  3: '0.1875rem',
  // for elevations
  2: '0.125rem',
  1.46: '0.09125rem',
  1: '0.0625rem'
};
var ELEVATIONS = {
  NavBar: "0 -".concat(SIZES['1'], " ").concat(SIZES['3'], " 0 ") + COLORS.grey,
  ToggleBody: "inset 0 -".concat(SIZES['3'], " ").concat(SIZES['3'], " -").concat(SIZES['3'], " ") + COLORS.grey,
  AppBar: "0 ".concat(SIZES['4'], " ").concat(SIZES['4'], " 0 rgba(188, 190, 198, 0.6)"),
  FAB: "0 ".concat(SIZES['2'], " ").concat(SIZES['4'], " 0 ") + COLORS.darkGrey,
  Button: "0 ".concat(SIZES['2'], " ").concat(SIZES['2'], " 0 ") + COLORS.grey,
  Dialog: "0 ".concat(SIZES['2'], " ").concat(SIZES['4'], " 0 ") + COLORS.black + '66',
  Card: "0 ".concat(SIZES['1'], " 0 0 ") + COLORS.grey,
  ToggleHeader: "0 ".concat(SIZES['2'], " ").concat(SIZES['4'], " -").concat(SIZES['2'], " ") + COLORS.darkGrey,
  Accordion: "inset 0 ".concat(SIZES['3'], " ").concat(SIZES['2'], " -").concat(SIZES['2'], " ").concat(COLORS.darkGrey, ", inset 0 -").concat(SIZES['3'], " ").concat(SIZES['2'], " -").concat(SIZES['2'], " ").concat(COLORS.darkGrey),
  ToggleHeaderInset: "inset 0 -".concat(SIZES['2'], " ").concat(SIZES['4'], " -").concat(SIZES['2'], " ") + COLORS.darkGrey,
  PlayButton: "0 ".concat(SIZES['2'], " ").concat(SIZES['4'], " 0 rgba(0, 0, 0, 0.5)")
};
export { COLORS, FONTS, ICONSIZES, SIZES, ELEVATIONS };
//# sourceMappingURL=styleVars.js.map